import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { CrosscuttingModule } from '@crosscutting/public_api';
import { environment } from '../../environments/environment';

import { StubInterceptor } from '../../../../services/src/lib/interceptors/stub.interceptor';
import { ServerErrorsInterceptor } from '../../../../services/src/lib/interceptors/server-errors.interceptor';
import { DisableCacheInterceptor } from '../../../../services/src/lib/interceptors/disable-cache.interceptor';
import { WafInterceptor } from '../../../../services/src/lib/interceptors/waf.interceptor';

import { GraphQLModule } from '../../../../services/src/lib/graphql.module';
import { SiteSettingsService } from '../../../../services/src/lib/service-agents/site-settings.service';
import { GraphQLVMService } from './graphQLVM.service';
import { VeiligheidsMeterService } from './veiligheidsmeter.service'

const nonProductionProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: StubInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: DisableCacheInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: WafInterceptor,
    multi: true
  }];

const productionProviders = [{
  provide: HTTP_INTERCEPTORS,
  useClass: DisableCacheInterceptor,
  multi: true
},
{
  provide: HTTP_INTERCEPTORS,
  useClass: ServerErrorsInterceptor,
  multi: true
},
{
  provide: HTTP_INTERCEPTORS,
  useClass: WafInterceptor,
  multi: true
}];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    CrosscuttingModule.forRoot(),
    GraphQLModule
  ],
  declarations: []
})
export class VMServicesModule {
  static forRoot(): ModuleWithProviders<VMServicesModule> {
    return {
      ngModule: VMServicesModule,
      providers: [
        environment.production ? productionProviders : nonProductionProviders,
        VeiligheidsMeterService,
        GraphQLVMService,
        SiteSettingsService
      ],
    };
  }
}
